// import Cookies from 'js-cookie';
import { useEffect } from 'react';
import { useUser } from '../../contexts/user';
import { useNavigate } from 'react-router-dom';

export const Logout = () => {
  const { setUser } = useUser();
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem('token');
    setUser({ isLoggedIn: false });
    console.log('asassa');
    navigate('/auth/sign-in');
  }, []);
  return <></>;
};
